<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg" style="font-size: 14px; overflow-y: auto;">
    <h2 class="mt-n3 text-center">Welcome Back</h2>
    <div class="mt-3">
      <p>
        We hope you are enjoying PartnerLists.  We've loved <span class="emphasis">helping you grow</span>
        your business with leads from vendors you already work with.
      </p>
      
      <p><strong><em>Your trial has expired!</em></strong></p>

      <p>
        To continue to use PartnerLists and get leads from your partners please click 
        below to re-activate your membership.
      </p>
    </div>
    <div class="d-flex justify-center mt-4">
      <later-dialog />
      <v-btn color="primary" class="ml-3" @click="setupNowClick">
        Update Now
      </v-btn>
    </div>
    <div class="mt-8">
      Please note: your account is now in read-only mode, and you will 
      <span class="emphasis">NO LONGER</span> receive leads. Your account will be
      deleted 90 days after the membership expiration date. During the 90 day
      period, you can view and add a payment method if you wish to re-activate
      your account.
    </div>
    <div class="text-center mt-6">
      <strong>Thank you for using PartnerLists.</strong>
    </div>
    <div class="text-center font-weight-bold mx-n2 mt-2" style="font-size: 18px;">
      <em>Get your vendors working for you today!</em>
    </div>
  </div>
</template>

<script>

import LaterDialog from './LaterDialog'
import { mapMutations } from 'vuex'

export default {
  name: 'ExpiredAlert',

  props: ['me'],

  components: { LaterDialog },

  methods: {
    ...mapMutations('alerts', ['SNOOZE']),

    setupNowClick() {
      this.SNOOZE('payment_method')
      window.history.replaceState(null, '', '/home')
      this.$router.push({ name: 'billing/account' })
    },
  },
}

</script>

<style scoped>
  .emphasis {
    color: green;
    font-weight: bold;
  }
</style>